import { formatISO } from 'date-fns'

import { SearchOffersDto } from '@wwt/entities/api/search-response'
import { FilterType } from '@wwt/entities/filters'

import { SearchRequest } from '@/entities/search'

export const searchRequestAdapterForRemote = (
	searchRequest: SearchRequest
): SearchOffersDto => {
	const prepared: SearchOffersDto = {
		...searchRequest,
		stay: {
			...searchRequest.stay,
			defaultStayPeriod: {
				checkIn: formatISO(searchRequest.stay.defaultStayPeriod?.checkIn, {
					representation: 'date'
				}),
				checkOut: formatISO(searchRequest.stay.defaultStayPeriod?.checkOut, {
					representation: 'date'
				})
			}
		}
	}

	if (searchRequest.filters) {
		// TODO: Move to util and write tests
		prepared.filters = searchRequest.filters?.map(filter => {
			let rangeUpper: number | null = null

			if (filter.type === FilterType.PRICE_RANGE) {
				// Set rangeUpper for price if price is bigger than max(defaultMax is max + 1)
				if (filter.defaultMax === filter.rangeUpper) {
					// We can't mutate filter.rangeUpper because its readOnly
					rangeUpper = -1
				}
			}

			if (
				filter.type === FilterType.PRICE_RANGE ||
				filter.type === FilterType.RANGE
			) {
				// Filter defaultMax and defaultMin params from API request
				return {
					id: filter.id,
					type: filter.type,
					rangeLower: filter.rangeLower,
					rangeUpper: rangeUpper ?? filter.rangeUpper
				}
			}

			return filter
		})
	}

	return SearchOffersDto.parse(prepared)
}
